import React, { Fragment } from 'react';
import {
  string,
  node,
  oneOfType,
  bool,
  number,
} from 'prop-types';

import './Link.scss';

export default class Link extends React.Component {
  static propTypes = {
    to: oneOfType([string, bool]),
    children: node,
    dataSelectorId: string,
    dataSelectorIndex: number,
    target: string,
  }

  static defaultProps = {
    to: null,
    target: undefined,
    children: null,
    dataSelectorId: null,
    dataSelectorIndex: 0,
  }

  isInternal(to) {
    // If it's a relative url such as '/path',
    // 'path' and does not contain a protocol we can assume it is internal.
    if (to && to.indexOf && to.indexOf('://') === -1) {
      return true;
    }
    return false;
  }

  render() {
    const {
      to,
      children,
      dataSelectorId,
      dataSelectorIndex,
      target,
      ...rest
    } = this.props;

    // Render nothing if no "to"
    if (!to) {
      return <Fragment>{children}</Fragment>;
    }

    const isInternal = this.isInternal(to);

    if (isInternal) {
      // return (<ReactLink to={to} {...rest}>{children}</ReactLink>);
      // TODO force server side routing.
      // TODO an env to control client side / server side routing
      return (
        <a
          className="link-anchor"
          href={to}
          rel="noopener noreferrer"
          target="_self"
          data-selector-type="link"
          data-selector-value={dataSelectorId}
          data-selector-internal={isInternal}
          data-selector-index={dataSelectorIndex}
          {...rest}
        >
          {children}
        </a>
      );
    }

    return (
      <a
        className="link-anchor"
        href={to}
        rel="noopener noreferrer"
        target={target || '_blank'}
        data-selector-type="link"
        data-selector-value={dataSelectorId}
        data-selector-internal={isInternal}
        data-selector-index={dataSelectorIndex}
        {...rest}
      >
        {children}
      </a>
    );
  }
}
